import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { SELECTORS, ATTRIBUTES, getProductCard } from '@/scripts/core/global'

export class CardSwatch extends UcoastEl {
    static htmlSelector = 'card-swatch'
    cardWrapper: HTMLElement
    swatches: NodeListOf<HTMLButtonElement>

    constructor() {
        super()

        this.cardWrapper = q.rc(this, '.product-card-wrapper')
        this.swatches = q.rl('.card-swatch-button', this)

        this.swatches.forEach(swatch => {
            swatch.addEventListener('click', this.updateCard.bind(this))
        })
    }

    getSpinner(target: HTMLButtonElement) {
        return q.rs(SELECTORS.loadingOverlaySpinner, target)
    }

    async updateCard(e: Event) {
        e.preventDefault()
        const target = e.currentTarget as HTMLButtonElement
        if(!target) return
        const url = target.dataset.url
        if(!url || target.classList.contains('active')) return
        target.setAttribute('aria-disabled', 'true')
        target.setAttribute(ATTRIBUTES.loading, '')
        this.getSpinner(target).classList.remove('hidden')
        const wrapper = await getProductCard(url)
        this.cardWrapper.innerHTML = wrapper.outerHTML
    }
}
